import { render } from "./LogoCropper.vue?vue&type=template&id=6bc8d0cc&scoped=true"
import script from "./LogoCropper.vue?vue&type=script&lang=js"
export * from "./LogoCropper.vue?vue&type=script&lang=js"

import "./LogoCropper.vue?vue&type=style&index=0&id=6bc8d0cc&scoped=true&lang=css"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc8d0cc"]])

export default __exports__